import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.statNumber = parseInt(this.el.getAttribute('data-stats-number'));
        this.delay = parseInt(this.el.getAttribute('data-stats-delay'));
        this.statValue = this.el;
        this.isShown = false;
        // interception observer to trigger animation
        this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if (!this.isShown) {
                        this.animate();
                        this.isShown = true;
                    }
                }
            });
        }, {
            threshold: 0.5
        });

        // observe the element
        this.observer.observe(this.el);
    }

    animate() {
        if (this.delay == 0) {
            const interval = 200 / this.statNumber;
            let i = 0;
            const timer = setInterval(() => {
                this.statValue.innerHTML = i;
                if (i >= this.statNumber) {
                    clearInterval(timer);
                }
                i++;
            }, interval);
        } else {
            const interval = 1500 / this.statNumber;
            let i = 0;
            const timer = setInterval(() => {
                this.statValue.innerHTML = i;
                if (i >= this.statNumber) {
                    clearInterval(timer);
                }
                i++;
            }, interval);
        }
    }
}
